import React, { forwardRef, useEffect, useState } from "react";
import axios from "axios";
import { compose } from "ramda";
import { withFirebase } from "react-redux-firebase";
import { connect } from "react-redux";
import styled from 'styled-components'
import { useInView } from "react-intersection-observer";

const getStockInfo = stock => {
  if (stock === 0) {
    return "Produced per order"
  } else {
    return `${stock}  in stock`
  }
}

const LevelIndicator = styled.span`
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 5px;
  background: ${({ $hasStock }) => $hasStock ? '#70c118' : '#ffc107'};
`

const ProductStock = forwardRef((props, ref) => {
  const [stock, setStock] = useState({ loading: true })
  const shouldLoad = props.shouldLoad === undefined || props.shouldLoad
  useEffect(() => {
    // call stock endpoint
    if (!shouldLoad) return
    setStock({ loading: true })
    axios.get(`/api/stock/${props.reference}`).then(response => {
      setStock(response.data)
    })
  }, [props.reference, shouldLoad])

  if (!props.auth.uid) return null
  const actualStock = stock.stock || 0
  return <p className="small" ref={ref}>
    {stock.loading 
      ? <>Loading stock information</> 
      : <>
        <LevelIndicator $hasStock={actualStock !== 0} />
        {getStockInfo(actualStock)}
      </>
    }
  </p>
})

const mapStateToProps = (state) => ({
  auth: state.firebase.auth,
})

const ProductStockContainer = compose(
  withFirebase,
  connect(mapStateToProps)
)(ProductStock);

export const ProductStockInViewWrapper = ({ shouldLoad = true, ...props }) => {
  const [ref, inView] = useInView({
    treshold: 0,
  });

  return (
    <ProductStockContainer
      {...props}
      ref={ref}
      shouldLoad={inView ? shouldLoad : false}
    />
  );
};

export default ProductStockContainer